<template>
  <div class="mining-pay-page">
    <!-- PC -->
    <div v-if="!isMobile" class="pc-wrap">
      <div class="pay-card">
        <div class="info-row">
          <span class="label">订单信息</span>
          <span class="value value-addr">充值 - {{ walletAddress }}</span>
        </div>
        <div class="info-row">
          <span class="label">订单编号</span>
          <span class="value">{{ orderNo }}</span>
        </div>
        <div class="divider" />
        <div class="highlight-box amount-box">
          <span class="label">支付金额</span>
          <span class="amount-val">{{ payAmount }} USDT</span>
        </div>
        <div class="highlight-box secure-box">
          <span class="secure-dot" />
          <span>安全支付通道已加密</span>
        </div>
        <div class="divider" />
        <p class="scan-tip">请使用钱包App扫描支付</p>
        <div class="qr-wrap">
          <canvas ref="qrCanvas" class="qr-canvas" />
          <div class="qr-usdt">
            <span class="usdt-icon">₮</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Mobile -->
    <div v-else class="mobile-wrap">
      <div class="pay-card">
        <div class="info-row">
          <span class="label">订单信息</span>
          <span class="value value-addr">充值 - {{ walletAddress }}</span>
        </div>
        <div class="info-row">
          <span class="label">订单编号</span>
          <span class="value">{{ orderNo }}</span>
        </div>
        <div class="divider" />
        <div class="highlight-box amount-box">
          <span class="label">支付金额</span>
          <span class="amount-val">{{ payAmount }} USDT</span>
        </div>
        <div class="highlight-box secure-box">
          <span class="secure-dot" />
          <span>安全支付通道已加密</span>
        </div>
        <div class="divider" />
        <div class="wallet-title-row">
          <span class="line" />
          <span>选择付款钱包</span>
          <span class="line" />
        </div>
        <div class="wallet-list">
          <div
            v-for="item in payList"
            :key="item.value"
            class="wallet-row"
            :class="{ active: checkedVal === item.value }"
            @click="checkedVal = item.value"
          >
            <img :src="item.src" :alt="item.title" class="wallet-icon" />
            <span class="wallet-name">{{ item.title }}</span>
          </div>
        </div>
        <button type="button" class="open-wallet-btn" @click="onPay">打开钱包支付</button>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcode';
import { message } from 'ant-design-vue';

const PAY_HOST = 'https://client.dcetnu.top';

export default {
  name: 'MiningPayment',
  data() {
    return {
      isMobile: false,
      detail: {},
      checkedVal: '',
      payList: [
        { title: 'imToken钱包', src: require('../assets/imtoken.jpg'), value: 'imtoken' },
        { title: 'TokenPocket', src: require('../assets/tokenpocket.jpg'), value: 'tokenpocket' },
        { title: 'TronLink钱包', src: require('../assets/tronlink.jpg'), value: 'tronlink' },
        { title: 'Bitget钱包', src: require('../assets/bitget.jpg'), value: 'bitget' },
      ],
    };
  },
  computed: {
    walletAddress() {
      return this.detail.walletAddress || this.detail.inputGT || '—';
    },
    orderNo() {
      return this.detail.orderNo || '—';
    },
    payAmount() {
      const p = Number(this.detail.price) || 0;
      const n = Number(this.detail.inputNumber) || 1;
      const total = p * n;
      return total % 1 === 0 ? String(total) : total.toFixed(2);
    },
    walletPayUrl() {
      const orderNo = encodeURIComponent(this.detail.orderNo || '');
      const code = encodeURIComponent(this.detail.referral_code || '');
      return `${PAY_HOST}/walletPay/tgNo/${orderNo}/referralCode/${code}`;
    },
  },
  mounted() {
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
    try {
      this.detail = JSON.parse(this.$route.params.data);
    } catch (e) {
      console.error('MiningPayment: invalid route data', e);
      message.error('订单数据无效');
      return;
    }
    if (!this.isMobile) {
      this.$nextTick(() => this.renderQr());
    }
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkMobile);
  },
  watch: {
    isMobile(val, oldVal) {
      if (!val && oldVal) {
        this.$nextTick(() => this.renderQr());
      }
    },
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
    },
    renderQr() {
      const canvas = this.$refs.qrCanvas;
      if (!canvas) return;
      QRCode.toCanvas(canvas, this.walletPayUrl, { width: 200, margin: 1 }, (err) => {
        if (err) console.error(err);
      });
    },
    onPay() {
      if (!this.checkedVal) {
        message.warning('请先选择付款钱包');
        return;
      }
      const url = this.walletPayUrl;
      if (this.checkedVal === 'imtoken') {
        window.location.href = `imtokenv2://navigate/DappView?url=${encodeURIComponent(url)}`;
      } else if (this.checkedVal === 'tokenpocket') {
        const param = encodeURIComponent(
          JSON.stringify({ url, chain: 'Tron', source: 'shopSer' })
        );
        window.location.href = `tpdapp://open?params=${param}`;
      } else if (this.checkedVal === 'bitget') {
        window.location.href = `https://bkcode.vip?action=dapp&url=${encodeURIComponent(url)}`;
      } else if (this.checkedVal === 'tronlink') {
        window.location.href = `tronlinkapp://open?url=${encodeURIComponent(url)}`;
      } else {
        window.location.href = url;
      }
    },
  },
};
</script>

<style scoped lang="less">
@page-bg: #e8eef5;
@card-gradient: linear-gradient(180deg, #3d7fd4 0%, #2a5a9e 55%, #1e4678 100%);
@glass: rgba(255, 255, 255, 0.12);
@label-color: rgba(255, 255, 255, 0.65);
@text-white: #fff;

.mining-pay-page {
  min-height: 100vh;
  background: @page-bg;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 16px;
}

.pay-card {
  width: 100%;
  max-width: 380px;
  background: @card-gradient;
  border-radius: 16px;
  padding: 24px 22px 28px;
  box-shadow: 0 12px 40px rgba(30, 70, 120, 0.35);
  color: @text-white;
}

.info-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 14px;
  font-size: 14px;

  .label {
    color: @label-color;
    flex-shrink: 0;
  }

  .value {
    text-align: right;
    word-break: break-all;
    line-height: 1.4;
  }

  .value-addr {
    font-size: 13px;
  }
}

.divider {
  height: 1px;
  background: rgba(255, 255, 255, 0.2);
  margin: 16px 0;
}

.highlight-box {
  background: @glass;
  border-radius: 10px;
  padding: 14px 16px;
  margin-bottom: 12px;
}

.amount-box {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .label {
    color: @label-color;
    font-size: 14px;
  }

  .amount-val {
    font-size: 20px;
    font-weight: 700;
  }
}

.secure-box {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.85);
}

.secure-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #52c41a;
  flex-shrink: 0;
}

.scan-tip {
  text-align: center;
  margin: 8px 0 20px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.9);
}

.qr-wrap {
  position: relative;
  display: flex;
  justify-content: center;
}

.qr-canvas {
  display: block;
  border-radius: 8px;
  background: #fff;
  padding: 8px;
}

.qr-usdt {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 40px;
  height: 40px;
  background: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.usdt-icon {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #26a17b;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Mobile wallet list */
.wallet-title-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 4px 0 16px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.85);

  .line {
    flex: 1;
    height: 1px;
    background: rgba(255, 255, 255, 0.25);
  }
}

.wallet-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 20px;
}

.wallet-row {
  display: flex;
  align-items: center;
  gap: 14px;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 12px;
  padding: 12px 16px;
  cursor: pointer;
  border: 2px solid transparent;

  &.active {
    border-color: #f5c518;
  }
}

.wallet-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  object-fit: contain;
}

.wallet-name {
  font-size: 15px;
  color: #222;
  font-weight: 500;
}

.open-wallet-btn {
  width: 100%;
  padding: 14px;
  border: none;
  border-radius: 12px;
  background: rgba(0, 0, 0, 0.35);
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;

  &:hover {
    background: rgba(0, 0, 0, 0.45);
  }
}

.pc-wrap,
.mobile-wrap {
  width: 100%;
  display: flex;
  justify-content: center;
}

@media (max-width: 768px) {
  .mining-pay-page {
    align-items: flex-start;
    padding-top: 16px;
  }

  .pay-card {
    max-width: 100%;
  }
}
</style>
